// CD-5421 "Paid Outside of System". The frontend twin of Tp_Communication's
// PaidOutsideOfSystemConstants: the one place the flag's user-facing wording lives, so the
// third-party job grid and the legacy assignment grid can never drift apart. Both stacks show the
// same row action, ask the same question and read the flag the same way - only the entity noun and
// the fee's name differ, which is why those are parameters.
export default class paidOutsideOfSystemHelper {
  static Label = 'Paid Outside of System';

  // The server sends a real bool, but a row whose value never arrived (undefined/null) must read as
  // "not flagged" rather than as truthy-unknown.
  static IsPaidOutsideOfSystem(item: any): boolean {
    return item?.PaidOutsideOfSystem === true;
  }

  // Names what the click will DO, not what the flag currently is.
  static GetToggleActionText(item: any): string {
    return paidOutsideOfSystemHelper.IsPaidOutsideOfSystem(item)
      ? `Clear ${paidOutsideOfSystemHelper.Label}`
      : `Mark ${paidOutsideOfSystemHelper.Label}`;
  }

  // Turning the flag ON is the consequential direction - it closes the payments that exist today.
  // Turning it OFF reverts nothing, and the message says so, so nobody expects a rollback.
  static GetToggleConfirmationMessage(turningOn: boolean, entityName: string, entityId: any, feeName: string): string {
    return turningOn
      ? `You are about to mark ${entityName} ${entityId} as paid outside of the system. The ${feeName} and reimbursement are kept, but the payment moves to the "${paidOutsideOfSystemHelper.Label}" status and will not be picked up by the Evaluator Payment Export.`
      : `You are about to clear "${paidOutsideOfSystemHelper.Label}" on ${entityName} ${entityId}. Payments already at that status stay there; only payments created from now on are affected.`;
  }
}
